import React, { useState } from "react";
import { Tabs } from "antd";
import styles from "./ActiveJob.module.css";
import { useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import Info from "./Info/Info";
import Instructions from "./Instructions/Instructions";
import Inventory from "./Inventory/Inventory";
import Message from "./Message/Message";
function ActiveJob() {
  const location = useLocation();

  console.log('location', location)
  const [Active, setActive] = useState();
  const { width, height } = useWindowDimensions()
  const { t } = useTranslation();
  const items = [
    {
      key: "1",
      label: `${t("Information")}`,
      children: <Info
        data={location}
      />,
    },
    {
      key: "2",
      label: `${t("Instructions")}`,
      children: <Instructions
        data={location}
      />,
    },
    {
      key: "3",
      label: `${t("Inventory")}`,
      children: <Inventory
        data={location}
      />,
    },
    {
      key: "4",
      label: `${t("Message")}`,
      children: <Message
        data={location}
      />,
    },
  ];

  if (location?.state.screen == 'pastjobs') {
    items.splice(1,3)
  }



  const onChange = (key) => {
    console.log(key);
  };

  return (
    <div className={styles.home_mainContainer}>
      <h1 className={styles.heading}>{t("Jobs")}</h1>
      <div className="tab_content_styling">
        <Tabs
          className="tab_content_styling"
          size="large"
          defaultActiveKey="1"
          items={items}
          tabBarGutter={width > 570 ? 50 : 5}
          centered
          onChange={onChange}
          tabBarStyle={width > 570 ? {
            color: "white",
            fontWeight: "bold",
            width: "100%",
          } : {
            color: "white",
            fontSize: '8px'
          }}

        />
      </div>
    </div>
  );
}

export default ActiveJob;
